<template>
    <b-container style="width:600px;">
        <b-card>
            <h3>Manage Product</h3>
            <br />
            <b-card-text>
                <b-input-group class="mb-3" prepend="Product Code">
                    <b-form-input trim autocomplete="off" v-model="form.product_code" type="text"
                        placeholder="Enter product code" :readonly="isEditing">
                    </b-form-input>
                    <b-input-group-append>
                        <b-button variant="success" @click="checkProduct">Check Product
                            <b-spinner v-if="isSending" class="m-1" label="Spinning" small />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>

                <div v-if="product">
                    <p>
                        <strong>Stripe Price ID:</strong> {{ product.stripe_price_id }}<br>
                        <strong>Name:</strong> {{ product.name }}<br>
                        <strong>Units For Teacher:</strong> {{ product.units_for_teacher.map(Number) }}<br>
                        <strong>Access Code Counts Unique Emails:</strong> {{ product.count_unique_emails ? 'Yes' : 'No' }}<br>
                    </p>
                    <b-button variant="success" v-if="!isEditing" @click="enableEditing">Update Product?</b-button>

                    <div v-if="isEditing">
                        <b-input-group class="mb-3" prepend="Stripe Price ID">
                            <b-form-input autocomplete="off" v-model="editableProduct.stripe_price_id"
                                type="text"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3" prepend="Name">
                            <b-form-input autocomplete="off" v-model="editableProduct.name" type="text"></b-form-input>
                        </b-input-group>
                        <div class="mb-3">
                            <label>Units For Teacher: </label>
                            <span>{{ editableProduct.units_for_teacher.map(Number) }}</span>
                            <b-form-select class="mt-2 mb-2" v-model="editableProduct.units_for_teacher"
                                :options="units_for_teacher_options" multiple :select-size="12"></b-form-select>
                        </div>
                        <b-form-checkbox class="mb-3" v-model="editableProduct.count_unique_emails">
                            Access codes count unique emails (re-use within a school)
                        </b-form-checkbox>
                        <b-button variant="success" class="mr-2 mb-2"
                            :disabled="!editableProduct.name || !editableProduct.stripe_price_id"
                            @click="updateProduct">Update</b-button>
                        <b-button class="mb-2" variant="success" @click="cancelEdit">Cancel</b-button>
                        <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
                    </div>
                </div>

                <div v-else-if="searched">
                    <span>No product found. Create a new product for {{ product_code }}</span>
                    <b-input-group class="mb-3" prepend="Stripe Price ID">
                        <b-form-input autocomplete="off" v-model="newProduct.stripe_price_id"
                            type="text"></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-3" prepend="Name">
                        <b-form-input autocomplete="off" v-model="newProduct.name" type="text"></b-form-input>
                    </b-input-group>
                    <div class="mb-3">
                        <label>Units For Teacher: </label>
                        <span>{{ newProduct.units_for_teacher }}</span>
                        <b-form-select class="mt-2 mb-2" v-model="newProduct.units_for_teacher"
                            :options="units_for_teacher_options" multiple :select-size="12">
                        </b-form-select>
                    </div>
                    <b-form-checkbox class="mb-3" v-model="newProduct.count_unique_emails">
                        Access codes count unique emails (re-use within a school)
                    </b-form-checkbox>
                    <b-button class="mb-2" variant="success" :disabled="!newProduct.name || !newProduct.stripe_price_id"
                        @click="createProduct">Create Product
                    </b-button>
                    <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
                </div>

            </b-card-text>

            <div v-if="invalid">
                Product Code, Stripe Price ID, and Name fields cannot be blank
            </div>

            <b-card-text>

            </b-card-text>
        </b-card>
    </b-container>
</template>

<script>
import {
    createProduct, updateProduct, checkProduct
} from "../../utils/twa-api"

export default {
    data() {
        return {
            form: {
                product_code: '',
            },
            product: null,
            product_code: '',
            name: '',
            staticUnitsForTeacher: '',
            isEditing: false,
            isSending: false,
            editableProduct: null,
            newProduct: {
                product_code: '',
                stripe_price_id: '',
                name: '',
                units_for_teacher: [],
                count_unique_emails: false,
            },
            invalid: false,
            searched: false,
            errorMessage: '',
            units_for_teacher_options: Array.from({ length: 19 }, (_, i) => ({
                value: i + 1,
                text: `Unit ${i + 1}`,
            })),
        }
    },


    methods: {
        handleLoginEvent(data) {
            this.isAuthenticated = data.loggedIn
            this.profile = data.profile
        },
        async enableEditing() {
            this.editableProduct = { ...this.product, units_for_teacher: [...this.product.units_for_teacher] }
            this.isEditing = true
        },
        async checkProduct() {
            this.errorMessage = ''
            this.isSending = true
            this.searched = false
            this.product_code = this.form.product_code
            this.isEditing = false
            this.newProduct.product_code = ''
            this.newProduct.name = ''
            this.newProduct.stripe_price_id = ''
            this.newProduct.units_for_teacher = []
            this.newProduct.count_unique_emails = false

            try {
                if (this.form.product_code) {
                    let response = await checkProduct(this.form.product_code)
                    this.product = response.product
                    if (this.product) {
                        this.product_code = this.product.product_code
                        this.stripe_price_id = this.product.stripe_price_id
                        this.name = this.product.name
                        this.staticUnitsForTeacher = this.product.units_for_teacher.slice().sort((a, b) => a - b)
                        this.invalid = false
                    }
                }
                else {
                    this.invalid = true
                }
                this.searched = true
            } catch (error) {
                console.log(error)
                this.searched = true
            }
            this.invalid = false
            this.isSending = false
        },
        async createProduct() {
            this.isSending = true
            this.errorMessage = ''
            try {
                if (this.form.product_code && this.newProduct.stripe_price_id && this.newProduct.name) {
                    this.newProduct.product_code = this.form.product_code
                    let response = await createProduct(this.newProduct.product_code,
                        this.newProduct.stripe_price_id,
                        this.newProduct.name,
                        this.newProduct.units_for_teacher,
                        this.newProduct.count_unique_emails)
                    this.errorMessage = response.message
                    if (this.errorMessage == null) {
                        this.product = { ...this.newProduct }
                        this.isEditing = false
                        this.stripe_price_id = this.product.stripe_price_id
                        this.name = this.product.name
                        this.staticUnitsForTeacher = this.product.units_for_teacher.slice().sort((a, b) => a - b)
                    }
                    this.invalid = false
                }
                else {
                    this.invalid = true
                }
            } catch (error) {
                console.log(error)
            }
            this.isSending = false
        },
        async updateProduct() {
            this.isSending = true
            this.errorMessage = ''
            this.invalid = false
            try {
                if (this.editableProduct.product_code && this.editableProduct.stripe_price_id && this.editableProduct.name) {
                    let response = await updateProduct(
                        this.editableProduct.product_code,
                        this.editableProduct.stripe_price_id,
                        this.editableProduct.name,
                        this.editableProduct.units_for_teacher,
                        this.editableProduct.count_unique_emails
                    )
                    this.errorMessage = response.message

                    if (this.errorMessage == null) {
                        this.product = { ...this.editableProduct };
                        this.isEditing = false
                        this.stripe_price_id = this.product.stripe_price_id
                        this.name = this.product.name
                        this.staticUnitsForTeacher = this.product.units_for_teacher.slice().sort((a, b) => a - b)
                    }
                }
                else {
                    this.invalid = true
                }
            } catch (error) {
                console.log(error)
            }

            this.isSending = false
        },
        async cancelEdit() {
            this.editableProduct = { ...this.product }; // Reset to original values
            this.isEditing = false;
            this.invalid = false;
        },
    }
}
</script>